export const Trust = [
  {
    value: 0,
    label: 'Overall',
  },
  {
    value: 1,
    label: 'Cypress lawn special care trust',
  },
  {
    value: 2,
    label: 'Olivet memorial special care trust',
  },
];

export const trustAgreementTypes = [
  {
    value: 0,
    label: 'Overall',
  },
  {
    value: 1,
    label: 'At Need',
  },
  {
    value: 2,
    label: 'Pre Need',
  },
];
